import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { getAutomaticCollectionNotificationDetails } from 'lib/api/collectionNotifications';
import { AutomaticCollectionNotification } from 'lib/api/collectionNotifications/types';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { formatDate } from 'lib/functions/utils';
import React from 'react';
import { useDispatch } from 'react-redux';

interface NotificationDetailsProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  collectionNotification: AutomaticCollectionNotification | null;
}

const NotificationDetails: React.FC<NotificationDetailsProps> = ({
  open,
  setOpen,
  collectionNotification,
}) => {
  const dispatch = useDispatch();
  const id = collectionNotification?.id ?? null;
  const { data, isLoading, isError } =
    getAutomaticCollectionNotificationDetails(dispatch, id);

  if (!collectionNotification) return null;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg" fullWidth>
      <DialogTitle>Detalles de la notificación</DialogTitle>
      <DialogContent>
        {isLoading && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: 24,
            }}
          >
            <CenteredCircularProgress type="dialog" />
          </div>
        )}
        {isError && (
          <Typography color="error">
            No se pudieron cargar los detalles.
          </Typography>
        )}
        {data && (
          <>
            <Typography variant="body2" color="text.secondary">
              Fecha de envío programada: {formatDate(new Date(data.sendDate))}
            </Typography>
            {data.sentAt && (
              <Typography variant="body2" color="text.secondary">
                Fecha de envío efectiva: {formatDate(new Date(data.sentAt))}
              </Typography>
            )}
            {data.recipients && data.recipients.length > 0 && (
              <Typography variant="body2" color="text.secondary">
                Destinatarios: {data.recipients.join(', ')}
              </Typography>
            )}
            <Box
              sx={{ marginTop: 2, '& img': { maxWidth: '100%' } }}
              dangerouslySetInnerHTML={{ __html: data.template }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton color="primary" onClick={() => setOpen(false)}>
          Cerrar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationDetails;
